<body>
    <div class="DetailsContainer">
        <label class="label" for="studentDetails">Students’ details</label>
        <div id="studentDetails" class="studentDetails">
            <img class="image" src="../../../../../assets/images/outing/profileIcon.png" alt="">
            <div class="StudentDataContainer">
                <span class="label" style="font-size: 14px;">{{profile.userName}}</span>
                <span style="font-size: 14px;">{{profile.admNo}}</span>
                <span class="row" style="width: 100%;">
                    <span style="font-size: 12px;">{{profile.campusName}}</span>
                    <!-- <span style="width: 15%;font-size: 12px;">Jr. Inter</span>
                    <span style="width: 15%;font-size: 12px;">NPL</span> -->
                </span>
            </div>
            <div class="count">
                <span class="otCnt">3</span>
                <span style="color: #FF6700;">Total Outing</span>
            </div>
        </div>
    </div>
    <div class="DetailsContainer">
        <label class="label" for="">Students’ Outing with</label>
        <div class="outingWithContainer">
            <ng-container *ngFor="let item of familyDetailsList">
                <div id="" class="dataContainer">
                    <img *ngIf="!familyImages[item.relationName]" class="image"
                        src="../../../../../assets/images/outing/user_with_camera.svg" alt="">
                    <img *ngIf="familyImages[item.relationName]" [src]="familyImages[item.relationName]" alt=""
                        style="width:60px;height: 60px; margin-left:5px ;" class="image">
                    <div class="StudentDataContainer">
                        <span class="label" style="font-size: 14px;">{{item.memberName}}</span>
                        <span style="font-size: 14px;">{{item.contactNumber}}</span>
                    </div>
                    <div class="select">
                        <label for="" class="relation">{{item.relationName}}</label>
                        <img class="selectedImage" *ngIf="selectedItem !== item.relationName" (click)="toggle(item)"
                            src="../../../../../assets/images/outing/notSelected.svg" alt="">
                        <img class="selectedImage" *ngIf="selectedItem === item.relationName" (click)="toggle(item)"
                            src="../../../../../assets/images/outing/selected.svg" alt="">
                    </div>
                </div>
            </ng-container>
            <div id="" class=" dataContainer" style="border: none;">
                <img class="image" src="../../../../../assets/images/outing/user_with_camera.svg" alt="">
                <button class="addHere" style="border: 1px solid #DE2424;color: #DE2424;" (click)="addNewMember()"> +
                    Add Here </button>
            </div>
        </div>

    </div>
    <div class="DetailsContainer">
        <label class="label" for="">Students’ Outing details</label>
        <div class="outingDetailsCoantianer">
            <div class="outingDataContainer">
                <div class="selection">
                    <label for="reasons" class="selectionLabel">Reason for Outing</label>
                    <mat-select id="reasons" class="matSelect" placeholder="Select" [(ngModel)]="selectedReason">
                        <input matInput [matAutocomplete]="losOptionsauto" [formControl]="reasonFilter"
                            class="autoCompleteInput inputborderpopup" placeholder=" Reason ">
                        <mat-autocomplete #losOptionsauto="matAutocomplete"></mat-autocomplete>
                        <mat-option *ngFor="let item of filteredreasons | async"
                            [value]="item">{{item.reason}}</mat-option>
                    </mat-select>
                </div>
                <div class="selection">
                    <label for="outDate" class="selectionLabel">Out Time</label>
                    <div class="demo-card" style="width: 100%;">
                        <div class="form-group" style="width: 100%;">
                            <input type="datetime-local" class="dateTimeInput" id="datetime1" [(ngModel)]="outTime"
                                [min]="minDateTime" [max]="maxDateTime" />
                        </div>
                    </div>
                </div>
                <div class="selection">
                    <label for="outDate" class="selectionLabel">In Time</label>
                    <div class="demo-card" style="width: 100%;">
                        <div class="form-group" style="width: 100%;">
                            <input type="datetime-local" class="dateTimeInput" id="datetime1" [(ngModel)]="inTime"
                                [min]="minDateTime" [max]="maxDateTime" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="note">
                <div class="update_list">
                    <label for="outDate" class="selectionLabel"
                        style="padding-left: 1%;margin-bottom: 10px;">Note</label>
                    <textarea name="" id="" class="text_area form-control" rows="6" maxlength="1000"
                        [(ngModel)]="studentGrievanceText" placeholder="Enter your Grievance"></textarea>
                    <!-- <div class="char-limit">Max : {{maxChar-studentGrievanceText.length}}/1000</div> -->
                </div>
            </div>
        </div>
    </div>
    <div class="DetailsContainer"
        style="display: flex;justify-content: center;align-items: center;margin-bottom: 20px;">
        <button class="outingReqSubmit" (click)="submitOutingRequest()">Submit</button>
    </div>
    <!-- ================================ loader ======================-->
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
</body>